import { useNavigate } from 'react-router-dom'
import { useDashboard } from '@/hooks/useDashboard'
import { DashboardSummaryCards } from '@/components/dashboard/DashboardSummaryCards'
import { ScoreTrend } from '@/components/dashboard/ScoreTrend'
import { TopRecommendations } from '@/components/dashboard/TopRecommendations'
import { OnboardingChecklist } from '@/components/onboarding/OnboardingChecklist'
import { SyncStatusBanner } from '@/components/sync/SyncStatusBanner'
import { TriggerAuditButton } from '@/components/audit/TriggerAuditButton'
import { Section } from '@/components/ui/Section'
import type { OnboardingStepKey } from '@/api/onboarding'

const STEP_ROUTES: Record<OnboardingStepKey, string> = {
  connect_store: '/',
  sync_data: '/',
  run_first_audit: '/audits',
  view_recommendations: '/recommendations',
  configure_schedule: '/audits',
  review_dashboard: '/',
}

export function DashboardPage() {
  const navigate = useNavigate()
  const { data } = useDashboard()

  return (
    <Section
      title="Dashboard"
      description="Your store growth overview"
      actions={<TriggerAuditButton remaining={data?.audits_remaining ?? undefined} />}
    >
      <div className="flex flex-col gap-6">
        <SyncStatusBanner />

        <OnboardingChecklist onNavigate={(step) => navigate(STEP_ROUTES[step])} />

        <DashboardSummaryCards />

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <TopRecommendations />
          {data && <ScoreTrend history={data.score_history} />}
        </div>
      </div>
    </Section>
  )
}
